import PropTypes from 'prop-types';

const routPropType = PropTypes.shape({
  path: PropTypes.string,
  exact: PropTypes.bool,
});

export default routPropType;
